<template>
  <div class="container mt-4">
    <!-- Top card with event details -->
    <EventViewTopCard
      :eventId="event.id"
    />

    <!-- Bottom card with registered users -->
    <EventViewBottomCard
      :registeredUsers="registeredUsers"
      :checkedInUsers="checkedInUsers"
      :eventId="event.id"
      :isPast="event.isPast()"
    />
  </div>
</template>

<script>
import EventViewTopCard from '../components/EventViewTopCard'
import EventViewBottomCard from '../components/EventViewBottomCard'
import EventsMixin from '../mixins/events'

export default {
  components: {
    EventViewTopCard: EventViewTopCard,
    EventViewBottomCard: EventViewBottomCard
  },
  mixins: [
    { methods: EventsMixin.methods },
    { created: EventsMixin.created }
  ],
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      event: {
        id: ''
      },
      registeredUsers: {},
      checkedInUsers: {}
    }
  },
  created () {
    this.fetchRegisteredUsers(this.event)
      .then(this.setRegisteredUsers)
  },
  methods: {
    setRegisteredUsers (users) {
      for (let user in users) {
        if (!users.hasOwnProperty(user)) continue
        users[user].id = user
        this.$set(this.registeredUsers, user, users[user])
        this.$set(this.checkedInUsers, user, users[user]['checked_in'])
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.event.hasOwnProperty('isPast')) {
      to.meta.showPast = this.event.isPast()
    }
    next()
  }
}
</script>
